<template>
  <header class="about">
    <h1>VirtueShare</h1>
  </header>
  <main>
    Content
    </main>
</template>
